import logo from './logo.svg';
import './App.css';
import Dictionary from "./Dictionary"
import ReactAudioPlayer from "react-audio-player";
import PhotosPexels from "./PhotosPexels";;

function App() {
  return (
    <div className="App">
      <div className="box">
        <header className="App-header">
          <div></div>
          <h1>
            <img src={logo} className="App-logo" alt="logo" />
            ord<strong>Finder </strong>
          </h1>
          <h2>
            {" "}
            Search the <strong className="colorYellow"> dictionary </strong> for
            a word's meaning and pronunciation
          </h2>
          <Dictionary />
        </header>

        <footer className="App-footer">
          Coded by
          <a href="https://github.com/jadeeg"> Jade Goncalves </a>
          and is open-sourced on{" "}
          <a href="https://github.com/jadeeg/Dictionary-"> GitHub</a> and hosted
          on <a href="https://vercel.com/"> Vercel </a>
        </footer>
      </div>
    </div>
  );
}

export default App;
